import styled from 'styled-components';

export const Root = styled.div(props => {
  const { isCollapsed } = props;

  return `
    position: absolute;
    top: 8px;
    left: ${isCollapsed ? '10px' : 'auto'};
    right: ${isCollapsed ? '' : '10px'}

    min-width: 16px;
    min-height: 16px;
    cursor: pointer;

    svg {
      width: 16px;
      height: 16px;
    }
  `;
});

export default Root;



// WEBPACK FOOTER //
// ./components/footer/resize-icon/styled.js